"use client";
import Link from "next/link";

export default function WorkplanCardComp({ item }: { item: any }) {
  return (
    <div className="group relative bg-white shadow-sm rounded-xl lg:rounded-2xl hover:shadow-md border border-solid border-gray-100">
      <Link href={`/work-plan?category=${item.id}`} className="cursor-pointer">
        <div className="bg-white rounded-xl lg:rounded-2xl relative overflow-hidden min-h-36">
          <div className="bg-gray-400 flex justify-center items-center">
            <img
              alt={item.name}
              src={item.imageSrc}
              className="aspect-square w-full rounded-t-xl lg:rounded-t-2xl object-contain group-hover:opacity-75 lg:aspect-auto h-40 max-h-40"
            />
          </div>
          <div className="ml-4 mt-4 max-h-20 h-20 overflow-hidden">
            <p className="text-dark font-semibold mb-2">{item.name}</p>
          </div>
        </div>
      </Link>
    </div>
  );
}
